import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function FaqCustomerAccordian(props) {
  const { accordianData } = props
  const navigate = useNavigate();
  const onClickCustomer = (title, id) => {
    const url = window.location.pathname.split("/")[2];
    if (url === 'faq') {
      navigate(`/configuration/faq/details/${props?.value}`, {state: {page: title, parentId: id, value:props.value}})
    }
  }
  return (
    <div>
      {accordianData?.map((ele, idx) => (
          <div key={ele.id}>
          {ele.FaqSubSections?.length > 0 ? (
            <Accordion className='accordianShadow'>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>
                  {ele.name}
                </Typography>
              </AccordionSummary>
              {ele?.FaqSubSections?.map((subele, idx) => (
                <AccordionDetails key={subele.id}>
                  <Typography
                    onClick={() => onClickCustomer(subele.name, subele.id)}
                    className='borderBottom'
                  >
                    {subele.name}
                  </Typography>
                </AccordionDetails>
              ))}
            </Accordion>
          ) : (
            <Grid className="accordianShadowSection">
              <Typography onClick={() => onClickCustomer(ele.name, ele.id)}>{ele.name}</Typography>
            </Grid>
          )}
        </div>

      ))}
    </div>
  )
}

export default FaqCustomerAccordian